﻿<script>
    import FormRow from './FormRow.svelte';
    import FormColumn from './FormColumn.svelte';
    import Checkbox from './Checkbox.svelte';
    import Select from './Select.svelte';

    import lookups from '../stores/lookupStore';
    //import { companyCapacityTypes } from '../config';

    export let name;
    export let capacityId;
    export let nzbn;
    export let authorisedToAct;
    export let disabled = null;
    export let required = null;
</script>


<FormRow>
    <FormColumn cols="12">
        <h3>Company Details</h3>
    </FormColumn>
</FormRow>

<FormRow>
    <FormColumn cols="4">
        <label for="name" class:isrequired={required}>Company Name</label>
        <input {required} {disabled} maxlength="1000" type="text" bind:value="{name}" id="name" class="form-control" />
    </FormColumn>
    <FormColumn cols="4">
        <label for="acnAbn" class:isrequired={required}>NZBN</label>
        <input {required} {disabled} maxlength="20" type="text" bind:value="{nzbn}" id="acnAbn" class="form-control" />
    </FormColumn>
    <FormColumn cols="4">
        <Select {required} {disabled} label="Capacity" bind:value="{capacityId}" id="capacity" optionList="{$lookups.companyCapacity}" textProperty="lookupName" valueProperty="id"></Select>
    </FormColumn>
</FormRow>

<FormRow class="align-items-end">
    <FormColumn cols="12">
        <Checkbox {disabled} bind:checked={authorisedToAct} label="I am authorised to register on behalf of the company" {required} id="authc"></Checkbox>
    </FormColumn>
</FormRow>
